/*
  Gaveesker for charms (Loulouis, laget av Claude 25.10.2026)

  Regelen:
  - Hver lenke (charmkjede eller charmarmbånd) får alltid én eske.
  - Charms uten lenke deler eske.
  - En eske tar maks 6 enheter, og en lenke teller som én. Tallet ligger i metafeltet
    custom.maks_per_eske på varen Gaveeske.
  - Kunden kan gå ned til det som får plass, og opp til én eske per smykke.
  - Esker innenfor regelen er varianten «Inkludert» (0 kr). Esker over regelen er «Ekstra».

  Slik virker det:
  - Etter hver endring i handlekurven (cart/add, change, update, clear) leser skriptet kurven
    og retter antall esker. Det gjelder også svar med feil og kall med XMLHttpRequest.
    Valget til kunden lagres i kurvattributtet _gaveesker_justering.
  - Telleren vises av snippets/ll-gaveesker.liquid i handlekurv-skuffen og på /cart.
  - Regnes ut likt i snippets/ll-gaveesker.liquid. Endrer du regelen, endre begge.
*/
(function () {
  'use strict';

  if (window.__llGaveesker) return;
  window.__llGaveesker = true;

  var cfg = window.LL_GAVEESKER;
  if (!cfg || !cfg.inkludert || !cfg.ekstra || typeof window.fetch !== 'function') return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var originalFetch = window.fetch.bind(window);
  var KURV = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var tidtaker = null;
  var opptatt = false;
  var neste = null; // null: ingenting i kø. 'auto': vanlig sjekk. Tall: antall esker kunden vil ha.

  function erLenke(item) {
    var tittel = String(item.product_title || '').toLowerCase();
    var handle = String(item.handle || '');
    return tittel.indexOf('halskjede') !== -1 ||
      tittel.indexOf('armbånd') !== -1 ||
      handle.indexOf('charm-necklace') !== -1 ||
      handle.indexOf('charm-bracelet') !== -1;
  }

  function beregn(kurv, onsket) {
    var lenker = 0;
    var enheter = 0;
    var inkludertNa = 0;
    var ekstraNa = 0;

    (kurv.items || []).forEach(function (item) {
      if (item.variant_id === cfg.inkludert) {
        inkludertNa += item.quantity;
      } else if (item.variant_id === cfg.ekstra) {
        ekstraNa += item.quantity;
      } else if (item.product_type === 'Charm') {
        enheter += item.quantity;
        if (erLenke(item)) lenker += item.quantity;
      }
    });

    var attributter = kurv.attributes || {};
    var lagret = attributter._gaveesker_justering;
    var justering = parseInt(lagret, 10);
    if (isNaN(justering)) justering = 0;

    var maks = parseInt(cfg.maksPerEske, 10);
    if (!(maks >= 1)) maks = 6;

    var malInkludert = 0;
    var malEkstra = 0;
    var nyJustering = 0;

    if (enheter > 0) {
      var minimum = Math.ceil(enheter / maks);
      var inkludert = Math.max(lenker, minimum);
      var valgt = typeof onsket === 'number' ? onsket : inkludert + justering;
      valgt = Math.min(enheter, Math.max(minimum, valgt));
      malInkludert = Math.min(valgt, inkludert);
      malEkstra = Math.max(0, valgt - inkludert);
      nyJustering = valgt - inkludert;
    }

    return {
      inkludertNa: inkludertNa,
      ekstraNa: ekstraNa,
      malInkludert: malInkludert,
      malEkstra: malEkstra,
      lagret: (lagret === undefined || lagret === null || lagret === '') ? '0' : String(lagret),
      nyJustering: String(nyJustering)
    };
  }

  function seksjoner() {
    var liste = [];
    if (document.getElementById('CartDrawer-Body')) liste.push('cart-drawer');
    if (document.getElementById('cart-counter')) liste.push('cart-counter');
    var hoved = document.getElementById('main-cart-items');
    if (hoved && hoved.dataset.id) liste.push(hoved.dataset.id);
    return liste;
  }

  function bytt(html, kilde, mal) {
    if (!html) return;
    var ny = new DOMParser().parseFromString(html, 'text/html').querySelector(kilde);
    var gammel = document.querySelector(mal);
    if (ny && gammel) gammel.innerHTML = ny.innerHTML;
  }

  function tegn(svar) {
    var s = (svar && svar.sections) || {};
    bytt(s['cart-drawer'], '#shopify-section-cart-drawer #CartDrawer-Body', '#CartDrawer-Body');
    bytt(s['cart-counter'], '#shopify-section-cart-counter', '#cart-counter');
    var hoved = document.getElementById('main-cart-items');
    if (hoved && hoved.dataset.id) {
      var id = hoved.dataset.id;
      bytt(s[id], '#shopify-section-' + id + ' cart-items', '#shopify-section-' + id + ' cart-items');
    }
    if (typeof window.updateFreeShipping === 'function') {
      try { window.updateFreeShipping(); } catch (e) { /* ikke viktig */ }
    }
  }

  function settOpptatt(verdi) {
    document.querySelectorAll('[data-ll-gaveesker]').forEach(function (blokk) {
      if (verdi) blokk.setAttribute('aria-busy', 'true');
      else blokk.removeAttribute('aria-busy');
    });
  }

  function kjor(onsket) {
    if (opptatt) {
      neste = typeof onsket === 'number' ? onsket : (neste === null ? 'auto' : neste);
      return;
    }
    opptatt = true;
    settOpptatt(true);

    originalFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (kurv) {
        var b = beregn(kurv, onsket);
        var oppdateringer = {};
        var endret = false;
        if (b.malInkludert !== b.inkludertNa) { oppdateringer[cfg.inkludert] = b.malInkludert; endret = true; }
        if (b.malEkstra !== b.ekstraNa) { oppdateringer[cfg.ekstra] = b.malEkstra; endret = true; }
        var nyAttributt = b.nyJustering !== b.lagret;
        if (!endret && !nyAttributt) return null;

        var kropp = { sections: seksjoner(), sections_url: window.location.pathname };
        if (endret) kropp.updates = oppdateringer;
        if (nyAttributt) kropp.attributes = { _gaveesker_justering: b.nyJustering };

        return originalFetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(kropp)
        }).then(function (r) { return r.json(); });
      })
      .then(function (svar) {
        if (svar && svar.status && svar.description) {
          console.warn('Gaveesker:', svar.description);
          return;
        }
        if (svar) tegn(svar);
      })
      .catch(function (feil) { console.warn('Gaveesker:', feil); })
      .then(function () {
        opptatt = false;
        settOpptatt(false);
        if (neste !== null) {
          var n = neste;
          neste = null;
          kjor(n === 'auto' ? undefined : n);
        }
      });
  }

  function planlegg() {
    clearTimeout(tidtaker);
    tidtaker = setTimeout(function () { kjor(); }, 80);
  }

  function erKurvAdresse(adresse) {
    return KURV.test(String(adresse || ''));
  }

  // Sjekk kurven også når Shopify svarer med feil. Ved for lite på lager legger Shopify
  // til det som finnes og svarer 422, så kurven kan være endret likevel.
  window.fetch = function (input, init) {
    var adresse = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
    var lofte = originalFetch(input, init);
    if (erKurvAdresse(adresse)) lofte.then(planlegg, planlegg);
    return lofte;
  };

  // Noen apper bruker XMLHttpRequest i stedet for fetch.
  if (window.XMLHttpRequest && XMLHttpRequest.prototype && XMLHttpRequest.prototype.open) {
    var openOriginal = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (metode, adresse) {
      try {
        if (erKurvAdresse(adresse)) this.addEventListener('loadend', planlegg);
      } catch (e) { /* ikke viktig */ }
      return openOriginal.apply(this, arguments);
    };
  }

  document.addEventListener('click', function (hendelse) {
    var knapp = hendelse.target && hendelse.target.closest ? hendelse.target.closest('[data-ll-gaveesker-endre]') : null;
    if (!knapp) return;
    hendelse.preventDefault();
    var blokk = knapp.closest('[data-ll-gaveesker]');
    if (!blokk || blokk.getAttribute('aria-busy') === 'true' || knapp.disabled) return;
    var valgt = parseInt(blokk.getAttribute('data-valgt'), 10) || 0;
    var endring = parseInt(knapp.getAttribute('data-ll-gaveesker-endre'), 10) || 0;
    kjor(valgt + endring);
  });

  if (Number(cfg.antallIKurv) > 0) kjor();
})();
